import React, { useState, useCallback, useContext } from 'react';
import { useRouter } from 'next/router';
import hive from '@bombas/hive';
import { useBreakpoint } from '../../util';
import SelectTile from '../Product/components/SelectTile/SelectTile';
import * as Styled from './ProductCardWithQuickAdd.styled';
import { usableNetEnabled, useOutsideClick, getCurrentColorDetails } from './ProductCard.utils';
import { useQuickAddModal } from '../QuickAddModal/QuickAddModal.context';
import { ContainerQueryContext } from '../../util/ContainerQuery.context';
import { handleNavigate } from '../../util/util';
/**
 * `ProductCardWithQuickAdd` displays a ProductCard with QuickAdd functionality.
 */
var ProductCardWithQuickAdd = function (_a) {
    var _b, _c;
    var badge = _a.badge, colors = _a.colors, customHtmlAttributes = _a.customHtmlAttributes, dataLabel = _a.dataLabel, defaultColorId = _a.defaultColorId, id = _a.id, onClick = _a.onClick, packDiscountCopy = _a.packDiscountCopy, productCardPosition = _a.productCardPosition, shopifyId = _a.shopifyId, sizes = _a.sizes, title = _a.title, url = _a.url, variants = _a.variants, callouts = _a.callouts;
    var router = useRouter();
    var _d = useState(false), forceEmbossShadow = _d[0], setForceEmbossShadow = _d[1];
    var _e = useState(false), showSizeOptions = _e[0], setShowSizeOptions = _e[1];
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    var _f = useState((defaultColorId && colors.find(function (c) { return c.id === defaultColorId; })) || colors[0]), selectedColor = _f[0], setSelectedColor = _f[1];
    var _g = getCurrentColorDetails(selectedColor, variants, sizes), currentColorVariants = _g.currentColorVariants, currentColorSizes = _g.currentColorSizes, currentColorCategory = _g.currentColorCategory, currentColorPrice = _g.currentColorPrice, currentColorQbsData = _g.currentColorQbsData;
    var large = useBreakpoint().large;
    var pdpLink = "".concat(url).concat(selectedColor ? "?variant=".concat(selectedColor.id) : '');
    var ref = useOutsideClick(function () {
        setForceEmbossShadow(false);
        setShowSizeOptions(false);
    });
    var handleOpen = useQuickAddModal().handleOpen;
    var openQuickAddModal = useCallback(function () {
        var _a;
        handleOpen({
            title: title,
            subtitle: (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.title) || '',
            image: "https:".concat((_a = currentColorVariants[0]) === null || _a === void 0 ? void 0 : _a.images[0].image.file.url),
            currentColorSizes: currentColorSizes,
            currentColorCategory: currentColorCategory,
            pdpLink: pdpLink,
            shopifyId: shopifyId,
            productCardPosition: productCardPosition,
            callouts: callouts
        });
    }, [
        currentColorPrice,
        currentColorCategory,
        currentColorSizes,
        title,
        currentColorVariants,
        callouts
    ]);
    var handleCardClick = function (event) {
        if (onClick) {
            onClick(event);
        }
        else {
            event.preventDefault();
            var targetUrl = event.currentTarget.getAttribute('href');
            if (targetUrl)
                handleNavigate(router, targetUrl);
        }
    };
    return (React.createElement(Styled.Emboss, { forceEmbossShadow: forceEmbossShadow, "$usableNetEnabled": usableNetEnabled, "$styleQueryMode": styleQueryMode },
        React.createElement(Styled.ProductCard, { id: id, shopifyId: shopifyId, dataLabel: dataLabel, colors: colors, images: (_c = (_b = currentColorVariants[0]) === null || _b === void 0 ? void 0 : _b.images) === null || _c === void 0 ? void 0 : _c.map(function (image) { return ({
                id: image.id,
                alt: image.title,
                src: "https:".concat(image.image.file.url)
            }); }), price: currentColorPrice, packDiscountCopy: packDiscountCopy, callouts: callouts, url: url, title: title, badge: (defaultColorId === (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.id) && badge) || undefined, forceOverflowEmbossShadow: forceEmbossShadow, onClick: handleCardClick, currentColor: selectedColor, onSwatchChange: function (e) {
                setSelectedColor(colors.find(function (c) { return c.id === e.target.value; }));
                hive.track('PRODUCT_CARD_COLOR_SWATCH_CLICK');
            }, clickOutsideRef: ref, productCardPosition: productCardPosition, qbsData: currentColorQbsData, "$usableNetEnabled": usableNetEnabled, "$styleQueryMode": styleQueryMode, onMouseEnter: function () { return large && setShowSizeOptions(true); }, onMouseLeave: function () { return large && setShowSizeOptions(false); }, customHtmlAttributes: customHtmlAttributes, renderBottomButton: sizes.length > 1 || !(currentColorSizes === null || currentColorSizes === void 0 ? void 0 : currentColorSizes.length)
                ? undefined
                : function () { return (React.createElement(React.Fragment, null,
                    React.createElement(Styled.QuickAdd, { link: pdpLink, setForceEmbossShadow: setForceEmbossShadow, showSizeOptions: showSizeOptions, setShowSizeOptions: setShowSizeOptions, openQuickAddModal: openQuickAddModal, "$usableNetEnabled": usableNetEnabled, productId: shopifyId }, currentColorSizes === null || currentColorSizes === void 0 ? void 0 : currentColorSizes.map(function (currentColorSize) { return (
                    // @ts-ignore-next-line
                    React.createElement(SelectTile, { id: currentColorSize.variantId, value: currentColorSize.value, key: currentColorSize.id, disabled: !currentColorSize.available, isUnavailable: !currentColorSize.available, note: currentColorSize.guidance || '', isPack: currentColorSize.itemCount > 1, packSize: currentColorSize.itemCount, category: currentColorCategory, dataLabel: "productCard_quickAdd_L2", type: "button" })); })))); } })));
};
export default ProductCardWithQuickAdd;
